import { YEARS_PER_PAGE } from '@/shared/constants/calendar';
import { Matcher } from 'react-day-picker';


export const getYearsRange = (anchorYear: number) => {
    // Выравниваем по блоку из 12 лет, начиная с кратного 12 + 1
    // (например, 2020–2031, 2032–2043)
    const start = anchorYear - (anchorYear % YEARS_PER_PAGE);
    return Array.from({ length: YEARS_PER_PAGE }, (_, i) => start + i);
};

export const getMaxDate = (disabled: Matcher | Matcher[] | undefined): Date | undefined => {
    if (!disabled) return undefined;
    const list = Array.isArray(disabled) ? disabled : [ disabled ];
    for (const m of list) {
        if (m && typeof m === 'object' && 'after' in m && m.after instanceof Date) {
            return m.after;
        }
    }
    return undefined;
};

export const getMinDate = (disabled: Matcher | Matcher[] | undefined): Date | undefined => {
    if (!disabled) return undefined;
    const list = Array.isArray(disabled) ? disabled : [ disabled ];
    for (const m of list) {
        if (m && typeof m === 'object' && 'before' in m && m.before instanceof Date) {
            return m.before;
        }
    }
    return undefined;
};
